<template>
    <div class="consultant-item">
        <div class="consultant-left-container">
            <div class="consultant-image-container">
                <img class="consultant-image" :src="data.imgUrl" :alt="data.imgAlt || ''"/>
            </div>
            <!-- ONLINE -->
            <div v-if="data.availability == 'available'">
                <button @click="show(data.name, data.availability)">
                    <div class="c2c-available">
                        <div class="c2c-filter">
                            <h1 class="consultant-status">{{t('Ledig')}}</h1>
                            <img class="consultant-tel-icon" src="../assets/click-on-call.png" alt="telephone" >
                        </div>
                    </div>
                </button>

                <div class="consultant-call-data">
                    <div class="price-per-minute">
                        {{data.pricePerMinute}} {{t('kr/minut')}} -
                        <span  class="min-fee"> {{t('minimum')}} {{data.minimumDuration}} {{t('minutter')}}</span>
                    </div>
                    <div class="garanteret"><a href="/handelsbetingelser">{{t('Garanteret tavshedspligt')}}</a></div>
                 </div>

                <!-- C2C BUTTON, IF SELECTED -->
                <div class="c2c-button" v-if="data.availability != 'away'">
                    <c2c-call-button
                      v-show="showButton"
                      :data="data"
                      :serverUrl="serverUrl"
                      @startCall="startCall"
                      @customerEnqueued="customerEnqueued"
                      @errorGateway="errorGateway"
                      @exit="hide">
                  </c2c-call-button>
                  <div v-if="callInitiated"  class="c2c-in-session">
                    <h2>{{t('VENT VENLIGST')}}</h2>

                    <div class="c2c-in-session-text">
                      <div>{{t('Konsultenten ringer dig nu op')}} </div>
                      <div>{{t('indenfor 10-15 sek')}}</div>
                      <div>{{t('fra')}} <strong>{{t('tlf.')}} {{t('35 15 61 73')}}</strong></div>
                    </div>
                  </div>
                  <div v-else-if="callFailed" class="c2c-failed-session">
                    <h2>{{t('VI BEKLAGER MEGET')}}</h2>

                    <div class="c2c-in-session-text">
                      <div>{{t('Opkaldet gik ikke igennem.')}}</div>
                      <div>{{t('Prøv venligst igen om')}}</div>
                      <div>{{t('et kort øjeblik')}}</div>
                    </div>
                  </div>
                </div>
            </div>

            <!-- BUSY -->
            <div v-else-if="data.availability == 'busy'">
                <button @click="show(data.name, data.availability)">
                    <div class="c2c-not-available">
                        <div class="c2c-filter">
                            <h1 class="consultant-status">{{t('Optaget')}}</h1>
                            <img class="consultant-tel-icon" src="../assets/click-on-call-red.png" alt="telephone" >
                        </div>
                    </div>
                </button>
                <div class="consultant-call-data">
                    <div class="price-per-minute">
                        {{data.pricePerMinute}} {{t('kr/minut')}} -
                        <span  class="min-fee"> {{t('minimum')}} {{data.minimumDuration}} {{t('minutter')}}</span>
                    </div>
                    <div class="garanteret"><a href="/handelsbetingelser">Garanteret tavshedspligt</a></div>
                </div>
                <!-- C2C BUTTON, IF SELECTED -->
                <div class="c2c-button">
                    <c2c-call-button
                      v-show="showButton"
                      :data="data"
                      :serverUrl="serverUrl"
                      @startCall="startCall"
                      @customerEnqueued="customerEnqueued"
                      @errorGateway="errorGateway"
                      @exit="hide">
                  </c2c-call-button>
                  <div v-if="callInitiated"  class="c2c-in-session">
                    <h2>{{t('VENT VENLIGST')}}</h2>

                    <div class="c2c-in-session-text">
                      <div>{{t('Konsultenten ringer dig nu op')}} </div>
                      <div>{{t('indenfor 10-15 sek')}}</div>
                      <div>{{t('fra')}} <strong>{{t('tlf.')}} {{t('35 15 61 73')}}</strong></div>
                    </div>
                  </div>
                  <div v-else-if="callFailed" class="c2c-failed-session">
                    <h2>{{t('VI BEKLAGER MEGET')}}</h2>

                    <div class="c2c-in-session-text">
                      <div>{{t('Opkaldet gik ikke igennem.')}}</div>
                      <div>{{t('Prøv venligst igen om')}}</div>
                      <div>{{t('et kort øjeblik')}}</div>
                    </div>
                  </div>
                </div>

                <div @click="show(data.name, data.availability)">
                    <div class="c2c-queue-message">
                        <div class="c2c-queue-message-text" >
                        <div>{{t('Estimeret tid')}}: {{data.estimatedTime}} m.</div>
                        <div>{{t('Kunder i kø')}}: {{data.previousCustomers-1}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- OFFLINE -->
            <div v-else>
                <button @click="show(data.name, false)">
                    <div class="c2c-away">
                        <div class="c2c-filter">
                            <h1 class="consultant-status">{{t('Logget ud')}}</h1>
                            <img class="consultant-tel-icon" src="../assets/click-on-call-grey.png" alt="telephone" >
                        </div>
                    </div>
                </button>
                <div class="consultant-call-data">
                    <div class="price-per-minute">
                        {{data.pricePerMinute}} {{t('kr/minut')}} -
                        <span  class="min-fee"> {{t('minimum')}} {{data.minimumDuration}} {{t('minutter')}}</span>
                    </div>
                    <div class="garanteret"><a href="/handelsbetingelser">{{t('Garanteret tavshedspligt')}}</a></div>
                </div>
                <div class="c2c-button">
                    <c2c-call-button
                      v-show="showButton"
                      :data="data"
                      :serverUrl="serverUrl"
                      @customerEnqueued="customerEnqueued"
                      @errorGateway="errorGateway"
                      @exit="hide">
                  </c2c-call-button>
                  <div v-if="callInitiated"  class="c2c-in-session">
                    <h2>{{t('VENT VENLIGST')}}</h2>

                    <div class="c2c-in-session-text">
                      <div>{{t('Konsultenten ringer dig nu op')}} </div>
                      <div>{{t('indenfor 10-15 sek')}}</div>
                      <div>{{t('fra')}} <strong>{{t('tlf.')}} {{t('35 15 61 73')}}</strong></div>
                    </div>
                  </div>
                  <div v-else-if="callFailed" class="c2c-failed-session">
                    <h2>{{t('VI BEKLAGER MEGET')}}</h2>

                    <div class="c2c-in-session-text">
                      <div>{{t('Opkaldet gik ikke igennem.')}}</div>
                      <div>{{t('Prøv venligst igen om')}}</div>
                      <div>{{t('et kort øjeblik')}}</div>
                    </div>
                  </div>
                </div>
              <div class="consultant-temp-info" @click="show(data.name, false)">
                <div class="c2c-info-message offline">
                  <div v-if="!data.text_on_grid" class="c2c-info-message-text">
                    <div><b>Online igen</b></div>
                    <div v-if="data.next_available">{{ data.next_available }}</div>
                    <div v-else>Tidspunkt ikke oplyst</div>
                  </div>
                  <div v-else class="c2c-info-message-text">
                    <div class="skills">{{ data.text_on_grid }}</div>
                  </div>
                </div>
                <div class="c2c-info-message offline white-top-border">
                  <div v-if="!data.text_on_grid" class="c2c-info-message-text">
                    <div class="online-request">{{ t('Bed mig komme online nu') }} >></div>
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="consultant-right-container">
            <div class="consultant-right-container1">
                <h1 class="consultant-name">{{data.name}}</h1>
                <div class="consultant-rating-container">
                    <star-rating :inline="true" :star-size="20" :read-only="true" :show-rating="false" v-model="data.ratings"></star-rating>
                    <span class="consultant-ratings-number">({{data.ratingsNum}})</span>
                </div>
                <ul class="consultant-skills">
                  <li class="consultant-skill-item" v-for="(skill, index) in data.skills" :key="index">
                    <a :href="categoryUrl+skill.slug+'/'">{{ skill.name }}</a>
                  </li>
                </ul>
            </div>
            <div class="consultant-right-container2">
                <div class="consultant-instructions">
                    <div class="h-50 bg-green">
                        {{t('Sådan ringer du')}}
                    </div>
                    <ul class="consultant-instructions-steps">
                        <Li>{{t('Opret bruger')}}</li>
                        <Li>{{t('Vælg konsulent')}}</li>
                        <Li>{{t('Klik på "Ring mig op"')}}</li>
                    </ul>
                </div>
            </div>

            <div v-if="customer" class="consultant-description">
                {{t('Har du lige haft en samtale med')}} {{data.name}} {{t('og nåede du ikke at give en anmeldelse? Kan du give en')}} anmeldelse <a href="/customer-info?sessions=1">{{t('her')}}</a> {{t('indenfor de næste 3 dage efter din samtale')}}.
            </div>

          <div class="consultant-description" v-html="data.description"></div>
        </div>

        <div class="consultant-info-container">
<!--            <div class="consultant-availability" v-if="data.availability == 'away'" >-->
<!--                <div class="consultant-multimedia">-->
<!--                    <div class="multimedia-btn">-->
<!--                        <button @click="showVideoPlayer = true">-->
<!--                            <img src="../assets/click-on-video.png">-->
<!--                            {{t('Video')}}-->
<!--                        </button>-->
<!--                        <media-player v-if="showVideoPlayer" :file="data.video" :mediaType="'video'" @cancel="hidePlayer"></media-player>-->
<!--                    </div>-->

<!--                    <div class="multimedia-btn">-->
<!--                        <button @click="showAudioPlayer = true">-->
<!--                            <img src="../assets/click-on-audio.png">-->
<!--                            {{t('Lyd fil')}}-->
<!--                        </button>-->
<!--                        <media-player v-if="showAudioPlayer" :file="data.audio" :mediaType="'audio'" @cancel="hidePlayer"></media-player>-->
<!--                    </div>-->

<!--                </div>-->
<!--                <div class="available-again">-->
<!--                    <div v-if="data.next_available && data.next_available != ''">-->
<!--                        <h2><span>Online igen:</span>{{data.next_available}}</h2>-->
<!--                    </div>-->
<!--                    <div v-else>-->
<!--                        <h2><span>Online igen:</span>Tidspunkt ikke oplyst</h2>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <h2>{{t('Om')}} {{data.name}}</h2>
            <div class="consultant-bio" v-html="data.bio">{{data.bio}}</div>
         </div>
        <div v-if="!emptyReviews" class="consultant-reviews-container">
            <h2>{{t('Anmeldelser')}}</h2>

            <!-- <button v-if="customer != null" @click="showNewReview = true">Lav en anmeldelse</button> -->
            <div v-show="showNewReview && customer != null">
                <consultant-review :data="data"
                             @confirm="confirmReview"
                             @cancel="cancelReview">
          </consultant-review>
            </div>

            <!-- IF THERE ARE REVIEWS -->
            <div class="consultant-review-item" v-for="(review, index) in data.reviews" :key="index">
                <div class="consultant-review-client">
                    <h3>
                        <span class="consultant-client-name">{{review.username}}</span>
                        <span class="consultant-review-time">{{review.date}}</span>
                        <span class="consultant-review-rate">
                            <star-rating
                              :inline="true"
                              :star-size="20"
                              :read-only="true"
                              :show-rating="false"
                              v-model="review.overall">
                            </star-rating>
                        </span>
                    </h3>
                    <div class="consultant-review-comment">
                        {{review.content}}
                    </div>
                </div>
            </div>

            <div class="more" v-if="showMoreBtn">
                <button @click="moreReviews">Se flere anmeldelser</button>
            </div>
        </div>
    </div>
    <!-- consultant-item -->
</template>
<script>
    // IMPORTS
    import axios from 'axios'
    import VueStarRating from 'vue-star-rating'
    import Vue from 'vue'
    import C2cCallButton from './C2cCallButton.vue'
    import MediaPlayer from './MediaPlayer.vue'
    import ReviewConsultant from './ReviewConsultant.vue'

    var interval = null;
    var queueInterval = null;

    // COMPONENT DATA
    export default {

      name: 'GridButton',

      // CONSULTANT/ CUSTOMER DATA
      props: {
        consultant: {
          type: Object
        }
      },

      computed: {
        emptyReviews: function () {
            return this.data.reviews == null || this.data.reviews.length == 0
        },
        callInitiated: function () {
            let returnVal = (this.callId     != null
                && this.call_status != 'failed'
                && this.call_status != 'no-answer'
                && this.call_status != 'canceled'
                && this.call_status != 'busy'
                && this.call_status != 'in-progress');

            return returnVal;
          },

          callFailed: function () {
            return (this.callId     != null
                && (this.call_status == 'failed'
                 || this.call_status == 'no-answer'
                 || this.call_status == 'canceled'
                 || this.call_status == 'busy'));
          }
      },

      // COMPONENT DATA
      data () {
        return {
            serverUrl : '',
            categoryUrl: '',
            data      : this.consultant,
            customer  : {},
            status    : null,
            showButton: false,
            showNewReview: false,
            showAudioPlayer: false,
            showVideoPlayer: false,
            successfullSession: true,
            call_status: '',
            callId: null,
            offset: 20,
            limit: 20,
            showMoreBtn: true
        }
      },

      // INITIALIZATIONS WHEN COMPONENT RENDERS
      mounted() {
        if (typeof window.serverUrl !== 'undefined') {
          this.serverUrl = window.serverUrl;
        } else {
          this.serverUrl = 'https://www.klarsyn24.dk/wp-json/k24/v1/';
        }

        if (window.k24CustomerData) {
          this.customer = window.k24CustomerData;
        } else {
          this.customer = null;
        }

        if (typeof window.locale !== 'undefined') {
          this.$translate.setLang(window.locale);
        }

        if (typeof window.categoryUrl !== 'undefined') {
          this.categoryUrl = window.categoryUrl;
        } else {
          this.categoryUrl = 'https://www.klarsyn24.dk';
        }

        if (this.limit > this.data.ratingsNum) {
          this.showMoreBtn = false;
        }

        this.data.pricePerMinute = this.consultant.pricePerMinute.toString().replace(".", ",");
        this.data.next_available = this.consultant.next_available || '';
      },

      // METHODS ON EVENTS
      methods: {

        show (name, availability) {
          if (availability) {
            this.ledigGoogleAnalytics(name);
          }
          else {
            this.optagetGoogleAnalytics(name)
          }
          // If customer is logged in, pass customer data to modal
          if(this.customer) {
            this.data.phones = this.customer.phones;
            this.data.CustomerId = this.customer.id;
          }

          // show button
          this.showButton = true;
        },

        /**
         * Closes opened modal
         * @return null
         */
        hide (customer) {
            console.log('Hide window');
            this.customer   = customer;
            this.showButton = false;
        },

        hidePlayer () {
            this.showVideoPlayer = false;
            this.showAudioPlayer = false;
        },

        moreReviews() {
            var url    = this.serverUrl+'consultant/ratings?consultant=' + this.data.ClairvoyantId + '&offset=' + this.offset + '&limit=' + this.limit;
            axios({
                method : 'get',
                url    : url,
            })
            .then((response) => {
                response.data.forEach(element => {
                    this.data.reviews.push(element);
                    this.offset += 1;
                });

                if (response.data.length == 0) {
                    this.showMoreBtn = false;
                }
            })
            .catch((error) => {
            console.log(error);
            })
        },

        confirmReview(review) {
            this.data.reviews.push(review);
            this.showNewReview = false;
        },

        cancelReview() {
            this.showNewReview = false;
        },

        customerEnqueued(customer_data) {
            console.log('Customer Enqueued');
            this.customer = customer_data.customer;
            this.hide(this.customer);
            this.$emit('customerVerified', {customer:this.customer});
            queueInterval = setInterval(() => {
                this.checkUpcomingCall();
            }, 5000);
        },

        checkUpcomingCall() {
            if (this.callId == null) {
                clearInterval(interval);
                return null;
            }
            var url    = this.serverUrl+'call/upcoming';
            axios({
            method : 'get',
            data   : {customer_id: this.customer_id},
            url    : url,
            })
            .then((response) => {
                this.call_status = response.data.call_status
                if (this.call_status == 'completed') {
                    this.session = false;
                    this.callId  = null;
                    this.successfullSession = true;
                    this.call_status  = '';
                    this.callEnded();
                    clearInterval(interval);
                }
                else if(this.callFailed){
                setTimeout(() => {
                    this.session = false;
                    this.callId  = null;
                    this.successfullSession  = false;
                    this.call_status  = '';
                }, 7000);
                }
            })
            .catch((error) => {
            console.log(error);
            })
        },

        callEnded() {
            this.$emit('endCall', true);
            this.showNewReview = true;
        },

        startCall(call_data) {
            this.callId = call_data.call_id;
            this.customer = call_data.customer;
            this.hide(this.customer);
            this.$emit('customerVerified', {customer:this.customer});
            interval = setInterval(() => {
                this.checkCall();
            }, 5000);
        },

        errorGateway(data) {
          console.log('error: '+ data.errorType);
          this.$emit('showError', {redirectionLink: data.redirectionLink, customerData: data.customerData, errorType:data.errorType});
        },

        checkCall() {
            if (this.callId == null) {
                if (this.successfullSession) {
                    this.callEnded();
                }
                clearInterval(interval);
                return null;
            }
            var url    = this.serverUrl+'call/status';
            axios({
                method : 'post',
                data   : {call_id: this.callId},
                url    : url,
            })
            .then((response) => {
                this.call_status = response.data.call_status
                if (this.call_status == 'completed') {
                    this.session = false;
                    this.callId  = null;
                    this.successfullSession = true;
                    this.call_status  = '';
                    this.callEnded();
                    clearInterval(interval);
                }
                else if(this.callFailed){
                  setTimeout(() => {
                    this.session = false;
                    this.callId  = null;
                    this.successfullSession  = false;
                    this.call_status  = '';
                  }, 7000);
                }
            })
            .catch((error) => {
              console.log(error);
            })
        },

        optagetGoogleAnalytics(name) {
            this.googleAnalyticsEvent({
                eventCategory: 'konsulent',
                eventAction: 'konsulent-ring-optaget',
                eventLabel: name
            });
        },

        ledigGoogleAnalytics(name) {
            this.googleAnalyticsEvent({
                eventCategory: 'konsulent',
                eventAction: 'konsulent-ring-ledig',
                eventLabel: name
            });
        },

        readMoreGoogleAnalytics(name) {
            this.googleAnalyticsEvent({
                eventCategory: 'konsulent',
                eventAction: 'konsulent-laes-mere',
                eventLabel: name
            });
        },
      },

      // COMPONENT USED FOR THE MODAL
      components: {
        'star-rating': VueStarRating,
        'c2c-call-button': C2cCallButton,
        'media-player': MediaPlayer,
        'consultant-review': ReviewConsultant
      }
    }
</script>
<style lang="css">

.c2c-in-session {
  width: 100%;
  max-width: 100%;
  background-color: #585857;
  position: absolute;
  font-size: 14px;
  top: 44%;
  transform: translateY(-50px);
  -webkit-transform: translateY(-50px);
  padding-bottom: 20px;
  z-index: 2;
  color: #ffffff;
}

.c2c-failed-session {
  width: 100%;
  max-width: 100%;
  background-color: #e04557;
  position: absolute;
  top: 44%;
  transform: translateY(-50px);
  -webkit-transform: translateY(-50px);
  padding-bottom: 20px;
  z-index: 2;
  color: #ffffff;
}

.c2c-failed-session h2,
.c2c-in-session h2 {
  text-align: center;
  font-size: 24px;
  color: #ffffff;
  font-weight: 700;
}

.c2c-in-session-text {
  margin: 0 auto;
  color: #ffffff;
}
.c2c-in-session-text div {
  text-align: center;
}

.empty-div {
    font-size: 28px;
    width: 100%;
    margin-top: 50px;
    padding: 5px;
    text-align: center;
}

.consultant-item{
    position: relative;
    overflow: hidden;
    padding: 30px 10px;
}
.consultant-item button{
    width: 100%;
    background: transparent;
    padding: 0px;
    border: 0 none;
}
.consultant-item button:hover{
    cursor: pointer;
}

.consultant-rating-container {
    text-align: left;
    margin-top: 15px;
}

.consultant-ratings-number{
    font-size: 12px;
    color: #000;
    position: relative;
    bottom: 4px;
    left: 5px;
}

.consultant-left-container {
    float: left;
    width: calc( 37% - 4px);
    max-height: 100%;
    border: 1px solid #14cc9a;
    position: relative;
}

.consultant-image-container{
    max-height: 358px;
    overflow: hidden;
}
.consultant-image {
    width: 100%;
    max-width: 100%;
}
.consultant-info-container{
    float: left;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    line-height: 24px;
    overflow: hidden;
    padding-left: 0;
}
.consultant-info-container h2{
    color: #787878;
    font-size: 20pt;
    font-weight: bold;
    margin-top: 25px;
    margin-bottom: 0;
}
.consultant-info-bio{
    color: #000;
    font-size: 16px;
    font-weight: 300;
    padding-bottom: 30px;
}

.consultant-right-container {
    width: calc(63% - 45px);
    float: left;
    padding-left: 45px;
    padding-top: 34px;
}

.consultant-right-container1{
    width: 45%;
    float: left;
}

.consultant-right-container2{
    width: 55%;
    float: left;
}




.consultant-skills-container {
    width: calc(63% - 90px);
    float: left;
    padding: 0 45px;
    padding-top: 34px;
}

.consultant-name{
    color: #354793;
    font-size: 32pt;
    font-weight: 600;
    margin: 0px;
}


.consultant-skills-container h2
{
    color: #787878;
    font-size: 20px;
    line-height: 24px;
    margin-top: 0px;
}


.consultant-info-container .consultant-availability {
    width: calc( 37% - 10px);
    /*background: #37bb93;*/
    padding: 8px 5px;
    margin-top: 25px;
    margin-bottom: 30px;
    display: inline-block;
}

.consultant-info-container .consultant-availability h2 {
    color: #fff;
    font-size: 22px;
    font-weight: 400;
    text-align: center;
    line-height: 32px;
    letter-spacing: 0.4px;
    margin-top: 0px;
}

.consultant-availability span{
    font-weight: 900;
    display: block;
}

.consultant-instructions {
    float: right;
    width: 100%;
    background-color: #37bb93;
    color: #fff;
    font-size: 20px;
    text-align: center;
}

.consultant-instructions .status-available{
    height: 50px;
    line-height: 50px;
    background-color: #01c190;
}
.consultant-instructions .status-busy{
    background-color: #e04557;
    height: 50px;
    line-height: 50px;
}
.consultant-instructions .status-away{
    background-color: #a5a5a5;
    height: 50px;
    line-height: 50px;
}


.consultant-instructions-steps {
    padding: 15px 0;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
    margin: 0;
}


.consultant-instructions-steps li {
    margin: 0;
    font-size: 20px;
    list-style-type: none;
    text-align: left;
    padding-bottom: 35px;
    border-left: 1px solid #fff;
    padding-left: 45px;
    margin-left: 35px;
    position: relative;
}


.consultant-instructions-steps li:before{
    width: 35px;
    height: 35px;
    font-size: 22px;
    text-align: center;
    line-height: 35px;
    border-radius: 50%;
}


.consultant-instructions-steps li:nth-child(1):before{
    content: '1';
    position: absolute;
    top: -5px;
    left: -20px;
    background-color: #80a0dd;

}


.consultant-instructions-steps li:nth-child(2):before{
    content: '2';
    position: absolute;
    top: -5px;
    left: -20px;
    background-color: #5a81ce;
}



.consultant-instructions-steps li:nth-child(3){
    padding-bottom: 0px;
    margin-bottom: 15px;
}


.consultant-instructions-steps li:nth-child(3):before{
    content:url('../assets/click-on-call.png');
    position: absolute;
    top: -5px;
    left: -25px;
    background-color: transparent;
}

.c2c-queue-message {
    width: 100%;
    max-width: 100%;
    background-color: #e04557;
    position: relative;
    padding: 9px;
    color: #fff;
}

.c2c-queue-message-text {
  margin: 0 auto;
  color: #ffffff;
}
.c2c-queue-message-text div {
  text-align: center;
}

.consultant-info-container {
    float: left;
    width: 100%;
    max-height: 100%;
    line-height: 24px;
    overflow: hidden;
    padding-left: 0px;
}

.c2c-available{
    height: 55px;
    background: transparent;
    color: white;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    border-radius: 0px 0px 8px 8px;
}

.c2c-not-available{
    height: 55px;
    background: transparent;
    color: white;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    border-radius: 0px 0px 8px 8px;
}

.c2c-away{
    height: 55px;
    background: transparent;
    color: white;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    border-radius: 0px 0px 8px 8px;
}

.c2c-available .c2c-not-available .c2c-away button {
    background: transparent;
    color: #a5a5a5;
    font-size: 27px;
    font-weight: 900;
    border: 0 none;
    opacity: 0.8;
    border-bottom: 1px solid #48cfae;
}
.c2c-available .c2c-not-available .c2c-away button:hover {
    cursor: pointer;
}

.c2c-filter{
    width: 100%;
    height: 100%;
    /*background-color: rgba(54,188,146,0.7);*/
    background-color: #01c190;
    text-align: center;
    line-height: 55px;
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: relative;
}
.c2c-not-available .c2c-filter{
    background-color: #e04557;
}
.c2c-away .c2c-filter{
    background-color: #a5a5a5;
}
.c2c-filter li{
    display: inline-block;
    margin: 0 34px;
    position: relative;
    top: 6px;
}

.consultant-status {
    color: #fff;
    font-size: 28px;
    font-weight: 400;
    margin: 0;
    text-align: center;
}

.consultant-tel-icon{
    position: absolute;
    top: -15px;
    right: 37px;
}

.consultant-skills{
    display: block;
    float: left;
    color: #2E282A;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    list-style-type: none;
    padding: 0px;
}

.consultant-skill-item a{
    color: #323232;
    text-decoration: none;
    padding-left: 5px;
    margin: 12px 0;
}

.consultant-skill-item:before{
    content: ">";
    color: #3f3f3f;
    font-size: 14px;
    font-weight: 900;
}

.consultant-description {
    float: left;
    color: #030303;
    line-height: 28px;
    margin-top: 45px;
}


.consultant-bio {
    float: left;
    color: #030303;
    line-height: 28px;
    padding: 10px 0;
    padding-bottom: 15px;
    margin-top: 10px;
}
.consultant-bio-more{
    display: block;
    color: #5482CB;
    font-size: 18px;
    line-height: 20px;
    margin-top: 10px;
}

.consultant-call-data{
    background: #fff;
    padding-top: 15px;
}

.price-per-minute{
    color: #36BC92;
    font-size: 18px;
    text-align: center;
    margin-bottom: 6px;
}

.min-fee{
    color: #36BC92;
}

.garanteret {
    color: #000;
    line-height: 40px;
    text-align: center;
}

.consultant-rating{
    height: 48px;
    color: #000;
    line-height: 60px;
    text-align: center;
}

.consultant-temp-info{
  margin-top: 7px;
}

.consultant-temp-info a{
    text-decoration: none;
}
.consultant-temp-info input,
.consultant-temp-info .dropdown {
    width:170px;
    height: 30px;
    font-size: 10px;
}
.c2c-button {
    z-index: 1;
}

 .consultant-multimedia {
    width: 20%;
    text-align: center;
    display: inline-block;
    vertical-align: middle;
}

.available-again {
    display: inline-block;
    width: 78%;
    vertical-align: middle;
    background: #a5a5a5;
}

.multimedia-btn {
    padding: 5px;
    width: 100%;
    background-color: #ffff;
    margin: 6px 0;
}


.multimedia-btn button img{
    width: 100%;
}

.consultant-reviews-container{
       width: 100%;
       max-width: 100%;
       padding-top: 25px;
       padding-bottom: 25px;
       position: relative;
       overflow: hidden;
}
.consultant-review-item{
    padding-bottom: 27px;
    border-bottom: 1px solid #E0BF73;
}

.consultant-review-item:last-child{
  border: 0 none;
}

.consultant-reviews-container h2{
    color: #787878;
    font-size: 20pt;
    font-weight: bold;
    margin-bottom: 0px;
}
.consultant-review-client h3{
    color: #707070;
    font-size: 16px;
    font-weight: 300;
    line-height: 19px;
}
.consultant-review-comment{
    font-size: 16px;
}
.consultant-review-time{
    padding-left: 10px;
    padding-right: 30px;
}
.consultant-review-rate{
    position: relative;
    top: 3px;
}


.other-consultants-container{
    margin-top: 75px;
    margin-bottom: 200px;
}

.other-consultant-item {
   display: inline-block;
   overflow: hidden;
   padding: 0 10px;
}

.other-consultant-name {
   display: block;
   color: #fff;
   font-size: 16px;
   text-align: center;
   background: #80a0dd;
   line-height: 40px;
}

.other-consultant-item img {
    width: 100%;
}

.c2c-info-message {
  width: 100%;
  max-width: 100%;
  background-color: #e04557;
  position: relative;
  padding: 9px;
  color: #fff;
  min-height: 50px;
  display: flex;
  align-items: center;
}

.c2c-info-message.offline {
  background-color: #a5a5a5;
}

.c2c-info-message-text {
  margin: 0 auto;
  color: #ffffff;
}

.c2c-info-message-text div {
  text-align: center;
}

.online-request {
  font-weight: 800;
}

.white-top-border {
  border-top: 1px solid #ffffff;
}

@media only screen and (max-width: 767px) {
    .consultant-left-container {
        float: none;
        margin: 0 auto;
        max-width: 350px;
        width: 100%;
    }

    .consultant-right-container {
        padding-left: 10px;
        float: none;
        padding-right: 10px;
        display: table-cell;
    }

    .consultant-right-container2 {
        margin: 0 auto;
        float: none;
        max-width: 335px;
        width: 100%;
    }

    .consultant-description {
        float: none;
        display: inline-block;
        width: 100%;
        text-align: center;
    }

    .consultant-info-container .consultant-availability {
        margin: 0 auto;
        max-width: 200px;
        width: 100%;
        display: block;
        margin-top: 21px;
    }

    .consultant-info-container h2,
    .consultant-bio,
    .consultant-reviews-container {
        padding: 10px;
    }
}

.more {
    padding: 20px 0;
    text-align: center;
}

.consultant-item .more button {
    width: unset;
    border: solid #d1b168;
    background-color: #d1b168;
    color: #fff;
}

@media only screen and (max-width: 767px) {
    .consultant-left-container {
        float: none;
        margin: 0 auto;
        max-width: 350px;
        width: 100%;
    }

    .consultant-right-container {
        width: 100%;
    }

    .consultant-right-container1 {
        width: 100%;
        margin: 0 auto;
        text-align: center;
    }

    .consultant-rating-container {
        text-align: center;
    }

    .consultant-skills {
        width: 100%;
    }

    .consultant-skills {
        width: 100%;
    }
}

.h-50 {
  height: 50px;
  line-height: 50px;
}

.bg-green {
  background-color: #01c190;
}
</style>



// WEBPACK FOOTER //
// src/components/GridButton.vue